function Hero() {
  return (
    <section id="hero">
      <div
        class="container flex flex-col-reverse items-center
          px-6 mx-auto space-y-0 md:space-y-0 md:flex-row justify-center"
      >
        <div class="flex flex-col mb-10 space-y-12 md:w-1/2">
          <h1 class="max-w-md text-4xl font-bold text-center md:text-5xl md:text-left">
            Welcome To My Personal Portfolio
          </h1>

          <p class="max-w-sm text-center text-darkGrayishBlue md:text-left">
            Welcome to my web app portfolio! I'm a passionate web developer,
            skilled in coding and design, dedicated to creating immersive user
            experiences. Explore my projects showcasing expertise in front-end
            development, back-end integration, and responsive design. Let's
            connect and discuss how I can contribute to your team's success.
            Thank you for visiting!
          </p>

          <div class="flex justify-center md:justify-start">
            <a
              href="#"
              class="w-full p-3 px-6 pt-2 text-white text-center bg-blue-500
              rounded-full baseline hover:bg-brightRedLight md:w-36"
            >
              Learn more
            </a>
          </div>
        </div>
        <div class="">
          <img
            src="images/sangwani.jpg"
            alt="Sangwani Mkondowe"
            class="hidden md:block w-48 h-auto rounded-md shadow-md blur-md hover:blur-none duration-400 transition-all object-cover"
          />
        </div>
      </div>
    </section>
  );
}

export default Hero;
